import Node from './component.vue';

export default {
    name: 'node',
    props: ['app', 'node'],
    components: {
        Node
    }
};
